import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import React from 'react';

const PhysiotherapyModalConfirm = ({
    submitModal,
    onComplete,
    closeModal,
    modalIsOpen,
    className,
    requestId
}) => {

    const handleSubmit = () => {
        submitModal()
        .then(() => {
            closeModal()
            onComplete()
        })
    }

    return <Modal
        isOpen={modalIsOpen}
        toggle={closeModal}
        className={className}
    >
        <ModalHeader className="bg-primary" toggle={closeModal}>
            Confirm Request (Request Id: {requestId})
        </ModalHeader>
        <ModalBody>
            <p>Are you sure you want to confirm this request?</p>
        </ModalBody>
        <ModalFooter>
            <Button color="info" onClick={handleSubmit}>
                Confirm
            </Button>
            <Button color="secondary" onClick={closeModal}>
                Close
            </Button>
        </ModalFooter>
    </Modal>
}

export default PhysiotherapyModalConfirm